'use strict';

jQuery(document).ready(function ($) {

	$('#psp-phases, #psp-archive-content').on('click', '.complete-sub-task-link', function (e) {

		e.preventDefault();

		var formID = $(this).attr('data-target');
		var project_id = $(this).attr('data-project');
		var phase_id = $(this).attr('data-phase');
		var parent_id = $(this).attr('data-parent_id');
		var task_id = $(this).attr('data-task');
		var progress = 100;

		var phase_progress = $(this).attr('data-phase-auto');
		var total_progress = $(this).attr('data-overall-auto');

		// Single, Dashboard, and Your Tasks view
		var $parentTask = $('.psp-single-' + project_id + ' .phase-' + (parseInt(phase_id) + 1) + ' .task-item-' + parent_id + ', .psp-task-project-' + project_id + ' .task-item-' + parent_id + ', .project-' + project_id + '-task-' + parent_id);

		// Update dynamically
		psp_update_sub_task_progress(project_id, phase_id, task_id, parent_id, $parentTask, progress, phase_progress, total_progress);

		var the_parent = $(this).parents('.sub-task-item-' + task_id),
		    target = $(the_parent).children('span').children('em');

		if (progress == '100') {
			$(the_parent).addClass('complete');
		} else {
			$(the_parent).removeClass('complete');
		}

		$(target).removeClass().addClass('status').addClass('psp-' + progress);
		$(the_parent).attr('data-progress', progress);
	});

	$('#psp-phases, #psp-archive-content').on('click', '.sub-task-save-button', function (e) {

		e.preventDefault();

		var task_element = $(this).siblings('#edit-sub-task-select-' + $(this).attr('data-phase') + '-' + $(this).attr('data-task'));

		var project_id = $(this).attr('data-project');
		var phase_id = $(this).attr('data-phase');
		var parent_id = $(this).attr('data-parent_id');
		var task_id = $(this).attr('data-task');
		var progress = $(task_element).val();
		var parent_div = $(this).parents('.task-select');

		var phase_progress = $(this).attr('data-phase-auto');
		var total_progress = $(this).attr('data-overall-auto');

		// Single, Dashboard, and Your Tasks view
		var $parentTask = $('.psp-single-' + project_id + ' .phase-' + (parseInt(phase_id) + 1) + ' .task-item-' + parent_id + ', .psp-task-project-' + project_id + ' .task-item-' + parent_id + ', .project-' + project_id + '-task-' + parent_id);

		psp_update_sub_task_progress(project_id, phase_id, task_id, parent_id, $parentTask, progress, phase_progress, total_progress);

		var the_parent = $(this).parents('.sub-task-item-' + task_id),
		    target = $(the_parent).children('span').children('em');

		$(target).removeClass().addClass('status').addClass('psp-' + progress);
		$(the_parent).attr('data-progress', progress);

		if (progress == '100') {
			$(the_parent).addClass('complete');
		} else {
			$(the_parent).removeClass('complete');
		}

		$(this).parents('.sub-task-select').fadeOut('slow');
	});

	$('#psp-phases, #psp-archive-content').on('click', '.sub-task-edit-link', function (e) {

		e.preventDefault();
		var the_parent = $(this).parents('li.sub-task-item');
		$(the_parent).children('.sub-task-select').fadeIn('slow');
	});
});

function psp_update_sub_task_progress(project_id, phase_id, task_id, parent_id, $parentTask, progress, phase_progress, total_progress) {

	var ajaxurl = jQuery('#psp-ajax-url').val();

	jQuery.ajax({
		url: ajaxurl + "?action=psp_update_sub_task_fe",
		type: 'post',
		data: {
			project_id: project_id,
			phase_id: phase_id,
			task_id: task_id,
			parent_id: parent_id,
			progress: progress
		},
		success: function success(response) {

			var phase_index = parseInt(phase_id) + 1;

			$parentTask.find('span.psp-progress-bar em').removeClass().addClass('status').addClass('psp-' + response.data.parent_progress);
			$parentTask.attr('data-progress', response.data.parent_progress);

			psp_update_my_task_count(project_id, phase_id);

			if (typeof phase_progress !== 'undefined' && phase_progress == 'Yes') {
				psp_update_phase_completion(project_id, phase_id);
			}

			if (typeof total_progress !== 'undefined' && total_progress == 'Yes') {
				psp_update_total_progress(project_id);
			}
		},
		error: function error(data) {
			console.log(data);
		}
	});
}
'use strict';

(function ($) {

	$(document).ready(function () {

		$('#psp-phases').on('click', '.fe-edit-task-link', function (event) {

			var target = $(this).attr('href');
			var $modal = $(target);
			var values = $(this).data();

			var subTasks = values['sub_task'];

			clearRepeater($modal);

			addRows(subTasks, $modal);

			$modal.find('input[data-fieldhelpers-field-datepicker]').each(function (index, preview) {

				var date = $(preview).next('input[type="hidden"]').val(),
				    month = date.substring(4, 6),
				    day = date.substring(6, 8),
				    year = date.substring(0, 4),
				    dateObject = new Date(year + '-' + month + '-' + day);

				// Don't populate a value if there is no due date
				if ($(preview).next('input[type="hidden"]').val() != '') {
					// https://stackoverflow.com/a/16048201
					dateObject.setTime(dateObject.getTime() + dateObject.getTimezoneOffset() * 60 * 1000);
				} else {
					dateObject = null;
				}

				$(preview).datepicker('setDate', dateObject);
			});
		});

		$('#psp-phases').on('click', '.psp-fe-add-element', function (event) {

			var target = $(this).attr('href');
			var $modal = $(target);

			clearRepeater($modal);
		});
	});

	/*
 $( document ).on( 'psp-fe-task-edit-modal-populated', function( event, $modal, values ) {
 		// With our Included Datepicker, we don't want to do it based on the field value. No tomfoolery necessary
 	$modal.find( 'input.psp-datepicker' ).each( function( index, field ) {
 			$( field ).datepicker();
 		} );
 	} ); */

	$(document).on('psp-fe-deleted-task', function (event, phase_index, task_index) {

		if (typeof rbmFHinitField === 'function') {

			// Re-init the Repeater field
			rbmFHinitField($('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"]').closest('.psp-frontend-field'));
		} else {
			// Oh well, Repeaters will be broken on Task Delete if an older RBM FH is running
		}
	});

	/**
  * Clears the Sub Task Repeater of all Values
  *
  * @param		{object} $modal Task Edit Modal jQuery Object
  *
  * @since		{{VERSION}}
  * @return		void
  */
	function clearRepeater() {
		var $modal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


		$modal.find('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"] .fieldhelpers-field-repeater-row').remove();
	}

	/**
  * Clears the Sub Task Repeater of all Values
  *
  * @param		{Array} subTasks      Array of Objects representing the values for each Row
  * @param		{object} $modal       Task Edit Modal jQuery Object
  *
  * @since		{{VERSION}}
  * @return		void
  */
	function addRows(subTasks) {
		var $modal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


		// Add Rows
		for (var subTask in subTasks) {

			$modal.find('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"] .fieldhelpers-field-repeater-add-button').click();
		}

		// Populate Rows
		$modal.find('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"] .fieldhelpers-field-repeater-row').each(function (index, row) {

			var subTask = subTasks[index];

			for (var key in subTask) {

				var value = subTask[key];

				$(row).find('*[name$="' + key + ']"]').val(value);
			}
		});
	}
})(jQuery);